import { useCallback } from 'react';

import { dateUtils } from 'shared_DEPRECATED/utils';

import { ChatMessageScheduleModalContent } from 'features/chat/components/ChatMessagesScheduling';
import { ScheduledForCallback } from 'features/chat/config/types/ScheduledMessage';

import { modal, SIZES } from 'shared/components/Modal';

export const useShowScheduledModal = () => {
  return useCallback(
    (onSubmit: ScheduledForCallback, scheduledFor?: string) => {
      modal.open({
        content: (
          <ChatMessageScheduleModalContent
            onSubmit={onSubmit}
            scheduledForDate={
              scheduledFor ? dateUtils(scheduledFor).toDate() : undefined
            }
          />
        ),
        props: { size: SIZES.AUTO },
      });
    },
    []
  );
};
